<div class="page">
    <div class="page-name">Audit Logs</div>

    <div class="tab-sec">
        <div class="tab-block">
            <div class="tab border-right">
                <a class="tab-link" routerLinkActive="active"  [routerLink]="'psr-publish-history'">PSR PUBLISH HISTORY</a>
            </div>
            <div class="tab border-right" *ngIf="isSuperAdmin">
                <a class="tab-link" routerLinkActive="active" [routerLink]="'activity-tracker'">ACTIVITY TRACKER</a>
            </div>
            <div class="tab" *ngIf="isSuperAdmin">
                <a class="tab-link" routerLinkActive="active" [routerLink]="'change-prior-tracker'">CHANGE PRIOR TRACKER</a>
            </div>
        </div>
    </div>

    <div class="content">
        <router-outlet></router-outlet>
    </div>

</div>